
function Player (eventBus, {x, y, paintColor}, map) {
    this.eventBus   = eventBus
    this.startCell  = map.getCell(x, y)
    this.paintColor = paintColor

    addNeighbourCellMethod(this, map)

    this.map = map //FIXME arf...

    this.reset()
}


Player.moveDirections = {
    left:   {x: -1, y:  0},
    right:  {x:  1, y:  0},
    up:     {x:  0, y:  1},
    down:   {x:  0, y: -1}
}


Player.prototype.reset = function () {
    let params = {
        cell: this.startCell,
        life: 100,
        lastDirection: null
    }

    this.godUpdate(params)
}


//FIXME
Player.prototype.godUpdate = function (params) {
    if ('cell' in params) {
        this.cell = this.map.getCell(params.cell.x, params.cell.y) //FIXME arf
    }

    if ('life' in params) {
        this.life = params.life
    }

    if ('lastDirection' in params) {
        this.lastDirection = params.lastDirection
    }

    this.eventBus.emit('player updated by God', this.cell, params) //FIXME bad params
}


Player.prototype.takeDamages = function (damages) {
    this.life = Math.max(0, this.life - damages)
    if (this.life === 0) {
        this.eventBus.emit('player died')
    }
}



Player.prototype.moveTo = function (targetCell, beforeToricCoords) {
    if (this.paintColor) {
        this.cell.updateColor(this.paintColor)
    }
    this.cell = targetCell
    this.eventBus.emit('player moved', targetCell, beforeToricCoords)
}


Player.prototype.move = function (direction) {
    let vector = Player.moveDirections[direction]

    let targetCoords = {
        x: this.cell.x + vector.x,
        y: this.cell.y + vector.y
    }

    let targetCell = this.neighbourCell(vector)

    if (!targetCell || targetCell.color === null) {
        this.eventBus.emit('player collided', targetCoords, direction)
        return
    }


    let beforeToricCoords = false

    if (targetCoords.x !== targetCell.x || targetCoords.y !== targetCell.y) {
        beforeToricCoords = targetCoords
    }

    this.lastDirection = direction
    this.moveTo(targetCell, beforeToricCoords)

}


Player.prototype.moveToNeighbour = function (position) {
    const vectorDirection = this.map.neighbourVectorDirection(this.cell, position)

    if (!vectorDirection) {
        return
    }

    const direction = directionNameFor(vectorDirection)

    if (direction) {
        this.move(direction)
    }
}


Player.prototype.again = function () {
    if (this.lastDirection) {
        this.move(this.lastDirection)
        return true
    } else {
        return false
    }
}



Player.prototype.cellColor = function () {
    return this.cell.color
}


// mecanism used to avoid adding 'map' to the player object
function addNeighbourCellMethod (player, map) {
    player.neighbourCell = function (vector) {
        return map.neighbourCellFor(player.cell, vector)
    }
}


function directionNameFor (vectorDirection) {
    for (let direction in Player.moveDirections) {
        let playerDirection = Player.moveDirections[direction]
        if (playerDirection.x === vectorDirection.x && playerDirection.y === vectorDirection.y) {
            return direction
        }
    }

    return null
}


export default Player

